import React from 'react';
import ReactPaginate from 'react-paginate';

const Pagnation = (props) => {

    const handlePageClick = (data) => {
        let selected = data.selected;
        props.click(selected)
    }

    return (
        <div className="pagination-table">
            <nav aria-label="Page navigation example " >
                <ReactPaginate
                    previousLabel={'⟨'}
                    nextLabel={'⟩'}
                    breakLabel={'..'}
                    pageCount={props.pageCount}
                    forcePage={props.currentPage}
                    onPageChange={handlePageClick}
                    subContainerClassName={'pages pagination'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-end'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    activeClassName={'active'}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                />
            </nav>
        </div>
    )
}

export default Pagnation